var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h5 class=\"workflow-help-title\">\n  		<i class=\"chevron fas fa-chevron-circle-up float-left\"></i>\n	  		Support \n	  	<i class=\"chevron fas fa-chevron-circle-up float-right\"></i>\n  </h5>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_docs/snippets/workflow-help-title.hbs
// module id = 48
// module chunks = 0